// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxsol } from "../../../icons/mono/build/icon-stataxsol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxsolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxsol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxsolIcon.displayName = 'StataxsolIcon';
}

export default StataxsolIcon;